<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="normal"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText"
  >
    <template #header>
      <span>导入标签</span>
    </template>
    <template #content>
      <gj-upload
        class="upload-btn"
        downloadTemplate
        templateUrl="/crm/tag/exportTagTemplate"
        container-type="tagOperation"
        @uploadAfter="importTag"
      >
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
        :rules="[
          '模板中的表头不可更改',
          '支持导入格式为xls/xlsx的文件',
          '模板字段若为非必填字段，且单元格不填值，系统将更新为空值',
        ]"
      >
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, uploadMixin } from "../../../../../minxins";
import { importTag } from "../../../../../api/system";

export default {
  name: "app-tag-import-modal",
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    importTag(attId, data, uploadCb) {
      this.importHandleLoading = true;
      importTag(attId)
        .then((res) => {
          this.$gjImportHandle(res, uploadCb)
        }).catch(() => {
            uploadCb('error')
          })
        .complete(() => (this.importHandleLoading = false));
    },
  },
};
</script>

<style scoped>
.upload-btn {
  margin-bottom: 16px;
}
</style>
